import { useUserRoleContext } from '../context/UserRoleContext';

export type UserRole = 'EMPLOYEE' | 'MANAGER' | 'ADMIN';

export interface UserRoleData {
  role: UserRole;
  work_area_ids?: number[];
  permissions?: {
    can_view_profile?: boolean;
    can_view_documents?: boolean;
  };
}

export type RoleErrorCode = 'tenant_header_missing' | 'tenant_user_missing' | 'insufficient_role' | 'unknown';

interface UseUserRoleReturn {
  role: UserRole | null;
  workAreaIds: number[];
  isAdmin: boolean;
  isManager: boolean;
  isEmployee: boolean;
  permissions: {
    can_view_profile: boolean;
    can_view_documents: boolean;
  };
  loading: boolean;
  error: Error | null;
  errorCode: RoleErrorCode | null;
}

export function useUserRole(): UseUserRoleReturn {
  return useUserRoleContext();
}
